import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from '../shared/api/http';
import { config } from './config';

// Единый обработчик протухшей сессии (блокер 5): любой 401 от защищённого
// эндпоинта → полный redirect на BFF login. Проба профиля (['profile'])
// исключена — для неё 401 это штатное «не залогинен» (показывается login-gate).
let redirecting = false;

// Онбординг — надстройка над интерфейсом: его 401 не означает протухшую сессию и не должен
// уводить работающего пользователя на логин. При живой сессии такой редирект возвращал на ту
// же страницу и повторялся по кругу (promt-85).
const noRedirectKeys = new Set(['profile', 'onboarding']);

function redirectToLogin(error: unknown, queryKey?: readonly unknown[]): void {
  if (!(error instanceof ApiError) || !error.isUnauthorized) return;
  if (typeof queryKey?.[0] === 'string' && noRedirectKeys.has(queryKey[0])) return;
  if (redirecting) return;
  redirecting = true;

  const returnUrl = window.location.pathname + window.location.search;
  window.location.href = `${config.apiBase}/auth/login?returnUrl=${encodeURIComponent(returnUrl)}`;
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => { redirectToLogin(error, query.queryKey); },
  }),
  mutationCache: new MutationCache({
    onError: (error) => { redirectToLogin(error); },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
